module.exports = __webpack_public_path__ + "img/b2.aa627a8b.png";